export default "__VITE_ASSET__BeYfHJ9z__"